(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fp-fleet-enquiry"] && !Shopify.designMode) return;
  try {
    
  class FpSelect extends HTMLElement {
    connectedCallback() {
      if (this.button) return;
      const select = this.querySelector('select');
      if (!select) return;
      this.select = select;
      const base = select.id;
      const label = document.getElementById(base + '-label');

      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.id = base + '-button';
      this.button.className = 'contact-form__input fp-select__button';
      this.button.setAttribute('role', 'combobox');
      this.button.setAttribute('aria-haspopup', 'listbox');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.setAttribute('aria-controls', base + '-list');
      if (label) {
        // Name it after the label, then the chosen value.
        this.button.setAttribute('aria-labelledby', label.id + ' ' + base + '-value');
        label.setAttribute('for', this.button.id);
      }
      if (select.required) this.button.setAttribute('aria-required', 'true');
      this.button.innerHTML = '<span class="fp-select__value" id="' + base + '-value"></span><span class="fp-select__caret" aria-hidden="true"></span>';

      this.list = document.createElement('ul');
      this.list.id = base + '-list';
      this.list.className = 'fp-select__list';
      this.list.setAttribute('role', 'listbox');
      if (label) this.list.setAttribute('aria-labelledby', label.id);
      this.list.hidden = true;

      this.placeholder = select.options[0] && select.options[0].value === '' ? select.options[0].text : '';
      this.options = [...select.options].filter((o) => o.value !== '').map((o, i) => {
        const li = document.createElement('li');
        li.id = base + '-opt-' + i;
        li.className = 'fp-select__option';
        li.setAttribute('role', 'option');
        li.textContent = o.text;
        li.dataset.value = o.value;
        li.addEventListener('mousedown', (e) => e.preventDefault());
        li.addEventListener('click', () => this.choose(i));
        li.addEventListener('mousemove', () => this.highlight(i, false));
        this.list.append(li);
        return li;
      });

      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      this.append(this.button, this.list);

      this.button.addEventListener('click', () => (this.list.hidden ? this.open() : this.close()));
      this.button.addEventListener('keydown', (e) => this.onKey(e));
      select.addEventListener('invalid', () => this.classList.add('is-invalid'));
      this.onOutside = (e) => {
        if (!this.contains(e.target)) this.close();
      };
      this.render();
    }

    get index() {
      return this.options.findIndex((li) => li.dataset.value === this.select.value);
    }

    render() {
      const i = this.index;
      this.button.querySelector('.fp-select__value').textContent = i > -1 ? this.options[i].textContent : this.placeholder;
      this.button.classList.toggle('is-placeholder', i < 0);
      this.options.forEach((li, n) => li.setAttribute('aria-selected', String(n === i)));
    }

    open() {
      this.list.hidden = false;
      this.classList.add('is-open');
      this.button.setAttribute('aria-expanded', 'true');
      this.highlight(Math.max(this.index, 0));
      document.addEventListener('pointerdown', this.onOutside);
    }

    close() {
      if (this.list.hidden) return;
      this.list.hidden = true;
      this.classList.remove('is-open');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.removeAttribute('aria-activedescendant');
      document.removeEventListener('pointerdown', this.onOutside);
    }

    highlight(i, scroll = true) {
      this.active = i;
      this.options.forEach((li, n) => li.classList.toggle('is-active', n === i));
      const li = this.options[i];
      if (!li) return;
      this.button.setAttribute('aria-activedescendant', li.id);
      if (scroll) li.scrollIntoView({ block: 'nearest' });
    }

    choose(i) {
      const li = this.options[i];
      if (!li) return;
      this.select.value = li.dataset.value;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));
      this.classList.remove('is-invalid');
      this.render();
      this.close();
      this.button.focus();
    }

    onKey(e) {
      const last = this.options.length - 1;
      const isOpen = !this.list.hidden;
      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          e.preventDefault();
          if (!isOpen) return this.open();
          this.highlight(Math.min(Math.max(this.active + (e.key === 'ArrowDown' ? 1 : -1), 0), last));
          break;
        case 'Home':
        case 'End':
          if (!isOpen) return;
          e.preventDefault();
          this.highlight(e.key === 'Home' ? 0 : last);
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          isOpen ? this.choose(this.active) : this.open();
          break;
        case 'Escape':
          if (isOpen) {
            e.preventDefault();
            this.close();
          }
          break;
        case 'Tab':
          this.close();
          break;
        default:
          if (e.key.length === 1 && /\S/.test(e.key)) {
            const k = e.key.toLowerCase();
            const from = isOpen ? this.active + 1 : this.index + 1;
            const order = [...this.options.keys()].map((n) => (n + from) % this.options.length);
            const hit = order.find((n) => this.options[n].textContent.trim().toLowerCase().startsWith(k));
            if (hit === undefined) return;
            isOpen ? this.highlight(hit) : this.choose(hit);
          }
      }
    }
  }

  if (!customElements.get('fp-select')) customElements.define('fp-select', FpSelect);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
